<!-- Loading bar -->
<!--<fuse-loading-bar></fuse-loading-bar>-->

<!-- Navigation -->
@let navigationState = $safeNavigationMigration(navigation()?.state);
@if (navigationState) {
  <fuse-vertical-navigation
    class="bg-default dark print:hidden"
    [navigationStateKey]="appState"
    [userPlan]="userPlan()"
    [appearance]="navigationAppearance()"
    [mode]="isScreenSmall() ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigationState"
    [opened]="!isScreenSmall()"
    [(static)]="isStatic"
    [user]="user()"
    (openedChanged)="isOpened.set($event)"
    (hoveredChanged)="isHovered.set($event)"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div
        class="mb-3 flex h-16 items-center border-b"
        [ngClass]="{
          'justify-between px-6':
            (isHovered() || isStatic() || isScreenSmall()) &&
            appState === 'app',
          'justify-center px-3': !isHovered() || appState !== 'app',
        }"
      >
        <img class="w-8" src="app_images/logo/logo.svg" alt="Logo image" />

        @if (
          appState === 'app' && (isHovered() || isStatic() || isScreenSmall())
        ) {
          <app-messages (open)="onWidgetOpened($event)"></app-messages>
        }
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex h-dvh w-full min-w-0 flex-col">
  <!-- Header -->
  <app-header
    class="sticky top-0 z-49 w-full shrink-0"
    (toggleNavigation)="toggleNavigation($event)"
  ></app-header>

  <!-- Content -->
  <div class="layout-content flex min-h-0 flex-1 flex-col overflow-y-auto">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <!--<div class="h-14 shrink-0 border-t px-4 md:px-6">Footer</div>-->
</div>
